import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Departamento, Empregador, Usuario } from '../../api.service';
import { RodapeCrudComponent } from '../../shared/rodape-crud.component';
import { ServicoMensagemAplicacao } from '../../shared/servico-mensagem-aplicacao';
import { PainelDadosUsuarioComponent } from './painel-dados-usuario.component';
import { SeletorUsuarioExistenteComponent } from './seletor-usuario-existente.component';
import { EstadoUsuarioCadastro, ServicoUsuarioAdministrativo } from './servico-usuario-administrativo';

@Component({
  selector: 'app-tela-usuarios',
  standalone: true,
  imports: [CommonModule, PainelDadosUsuarioComponent, RodapeCrudComponent, SeletorUsuarioExistenteComponent],
  templateUrl: './tela-usuarios.component.html'
})
export class TelaUsuariosComponent implements OnChanges {
  @Input() empregadores: Empregador[] = [];
  @Input() departamentos: Departamento[] = [];
  @Input() empregadorSelecionado = '';

  @Output() empregadorSelecionadoChange = new EventEmitter<string>();
  @Output() carregarDepartamentos = new EventEmitter<void>();
  @Output() mensagem = new EventEmitter<string>();

  usuarios: Usuario[] = [];
  usuarioSelecionado = '';
  usuario: Usuario = this.servicoUsuarioAdministrativo.novoUsuario();

  constructor(
    private readonly servicoUsuarioAdministrativo: ServicoUsuarioAdministrativo,
    private readonly servicoMensagemAplicacao: ServicoMensagemAplicacao
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['empregadorSelecionado']) {
      this.aplicarEstadoUsuario(this.servicoUsuarioAdministrativo.estadoLimpo(this.empregadorSelecionado));
      this.carregarUsuarios();
    }
  }

  selecionarUsuario(usuarioId: string) {
    this.aplicarEstadoUsuario(
      this.servicoUsuarioAdministrativo.estadoSelecionado(this.usuarios, usuarioId, this.empregadorSelecionado)
    );
  }

  selecionarEmpregador(empregadorId: string) {
    this.empregadorSelecionado = empregadorId;
    this.empregadorSelecionadoChange.emit(empregadorId);
    this.carregarDepartamentos.emit();
    this.limparUsuario();
    this.carregarUsuarios();
  }

  carregarUsuarios() {
    this.servicoUsuarioAdministrativo.listarPorEmpregadorSelecionado(this.empregadorSelecionado).subscribe({
      next: usuarios => this.usuarios = usuarios,
      error: () => this.mensagem.emit(this.servicoUsuarioAdministrativo.mensagemErroCarregarUsuarios())
    });
  }

  limparUsuario() {
    this.aplicarEstadoUsuario(this.servicoUsuarioAdministrativo.estadoLimpo(this.empregadorSelecionado));
  }

  salvarUsuario() {
    const editando = !!this.usuario.id;
    const usuario = this.servicoUsuarioAdministrativo.prepararSalvar(this.usuario, this.empregadorSelecionado);
    this.servicoUsuarioAdministrativo.salvar(usuario).subscribe({
      next: salvo => {
        this.mensagem.emit(this.servicoMensagemAplicacao.registroSalvo(editando));
        this.usuarioSelecionado = salvo.id || '';
        this.usuario = this.servicoUsuarioAdministrativo.prepararEdicao(salvo, this.empregadorSelecionado);
        this.carregarUsuarios();
      },
      error: erro => this.mensagem.emit(this.servicoMensagemAplicacao.erroApi(erro, this.servicoUsuarioAdministrativo.mensagemErroSalvar()))
    });
  }

  excluirUsuario() {
    if (!this.usuario.id || !window.confirm(this.servicoUsuarioAdministrativo.mensagemConfirmarExclusao())) {
      return;
    }

    this.servicoUsuarioAdministrativo.excluir(this.usuario.id).subscribe({
      next: () => {
        this.mensagem.emit(this.servicoMensagemAplicacao.registroExcluido());
        this.limparUsuario();
        this.carregarUsuarios();
      },
      error: () => this.mensagem.emit(this.servicoUsuarioAdministrativo.mensagemErroExcluir())
    });
  }

  private aplicarEstadoUsuario(estado: EstadoUsuarioCadastro) {
    this.usuarioSelecionado = estado.usuarioSelecionado;
    this.usuario = estado.usuario;
  }

}
